import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useCallback } from 'react';
import { ThemeProvider } from 'styled-components';
import ThemeSectionError from './error';
import getThemeSection from './getThemeSection';
function ThemeSection(_ref) {
  var name = _ref.name,
    withBackgroundImage = _ref.withBackgroundImage,
    children = _ref.children;
  var constructLocalTheme = useCallback(function (parentTheme) {
    if (!parentTheme) {
      throw new Error('ThemeSection must be used inside of a ThemeProvider component.');
    }
    if (!name && !withBackgroundImage) {
      return parentTheme;
    }
    var parentThemeSectionName = parentTheme.currentThemeSectionName;
    var resolvedName = name || parentThemeSectionName;
    var localThemeSection = getThemeSection({
      theme: parentTheme,
      name: resolvedName,
      withBackgroundImage: withBackgroundImage
    });
    if (!localThemeSection) {
      return parentTheme;
    }
    return _objectSpread(_objectSpread(_objectSpread({}, parentTheme), localThemeSection), {}, {
      currentThemeSectionName: resolvedName,
      parentThemeSectionName: parentThemeSectionName
    });
  }, [name, withBackgroundImage]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: constructLocalTheme
  }, children);
}
export { ThemeSectionError };
export default ThemeSection;